import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../atoms/Typography';
import { FeeAmount, FeeContainer, FeeDetails, FeeDivider, FeeName } from './style';

const OpportunityFee = ({ title, description, cost, currency }) => (
    cost > 0 && <>
      <FeeContainer>
        <FeeDetails>
          <FeeName variant="subtitle1">{title}</FeeName>
          <Typography variant="body2">
            {description}
          </Typography>
        </FeeDetails>
        <FeeAmount>
          <Typography variant="h2" color="primary">
            {cost}
          </Typography>
          <Typography variant="body1" weight="700">
            {currency}
          </Typography>
        </FeeAmount>
      </FeeContainer>
      <FeeDivider />
    </>
    
  );

OpportunityFee.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
};

export default OpportunityFee;
